import qs from 'qs'
import request from '@/utils/request'

const urlPrefix = '/office-equipments'

export function getOfficeEquipment (id) {
  return request.get(`${urlPrefix}/${id}`)
}

export function updateOfficeEquipment (id, data) {
  return request.put(`${urlPrefix}/${id}`, data)
}

export function deleteOfficeEquipment (id) {
  return request.delete(`${urlPrefix}/${id}`)
}

export function getOfficeEquipmentList (params) {
  return request.get(urlPrefix, { params })
}

export function createOfficeEquipment (data) {
  return request.post(urlPrefix, data)
}

export function exportOfficeEquipment (params) {
  return request.get(`${urlPrefix}/export`, {
    params,
    paramsSerializer: obj => {
      return qs.stringify(obj, { arrayFormat: 'repeat' })
    },
    responseType: 'blob'
  })
}

export function getOfficeEquipmentGroup (id, data) {
  return request.put(`${urlPrefix}/groups/${id}`, data)
}

export function updateOfficeEquipmentGroup (id, data) {
  return request.put(`${urlPrefix}/groups/${id}`, data)
}

export function deleteOfficeEquipmentGroup (id) {
  return request.delete(`${urlPrefix}/groups/${id}`)
}

export function getOfficeEquipmentGroupList () {
  return request.get(`${urlPrefix}/groups/tree`)
}

export function createOfficeEquipmentGroup (data) {
  return request.post(`${urlPrefix}/groups`, data)
}
